import React from 'react';
import '../../components/Contact/ImageWithDesc.css'; 

const ImageWithDesc = ({ heading = "ABOUT Timely Golf", dataLayout, srcImg }) => {
    return (
        <div className="image-with-desc">
            <div className="image-with-desc__container">
                <div className="image-with-desc__left">
                    <img src={srcImg} alt="Section Visual" className="image-with-desc__image" />
                </div>
                <div className="image-with-desc__right">
                    <h1 className="image-with-desc__heading">{heading}</h1>
                    <div className="image-with-desc__content">
                        {dataLayout}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageWithDesc;
